import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  faClipboardCheck,
  faUserHelmetSafety,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Modal, Row, theme, Typography } from 'antd';
import type { LinkedTechnician } from 'pos-client/hooks/useLocationLinkedTechnicians';

export const useConfirmNonScheduledTechnician = () => {
  const { t } = useTranslation();
  const { confirm } = Modal;
  const { token } = theme.useToken();

  return {
    confirmNonScheduledTechnician: (
      handleOk: () => void,
      technician: LinkedTechnician[]
    ) =>
      confirm({
        title: (
          <Typography.Text>
            {t('technicians.assigningNonScheduleTechs')}
          </Typography.Text>
        ),
        icon: null,
        content: (
          <>
            <Typography.Title level={4} style={{ marginTop: token.marginXXS }}>
              <FontAwesomeIcon
                color={token['orange-6']}
                icon={faUserHelmetSafety}
                style={{ marginRight: token.marginSM }}
              />
              {t('technicians.techConfirmation')}
            </Typography.Title>
            <Typography.Text>
              {t('technicians.technicianConfirmMessage')}
            </Typography.Text>

            <Typography.Title level={5}>
              {technician.length > 1
                ? t('technicians.technicians')
                : t('technicians.technician')}
            </Typography.Title>
            {technician.map((tech) => (
              <Row key={tech.id}>
                <Typography.Text strong>
                  {t('common.contact.name')}:{' '}
                </Typography.Text>
                <Typography.Text style={{ marginLeft: token.marginXXS }}>
                  {tech.name}
                </Typography.Text>
              </Row>
            ))}
          </>
        ),
        okText: t('technicians.confirmTechnician'),
        okType: 'primary',
        cancelText: t('common.buttons.cancel'),
        okButtonProps: {
          icon: <FontAwesomeIcon icon={faClipboardCheck} />,
          style: {
            backgroundColor: token.colorPrimary,
          },
        },
        cancelButtonProps: {
          style: {
            borderColor: token.colorPrimary,
            color: token.colorPrimary,
          },
        },
        footer: (_, { OkBtn, CancelBtn }) => (
          <Row
            gutter={token.marginSM}
            justify="end"
            style={{ paddingTop: token.marginLG }}
          >
            <Col style={{ marginRight: 'auto' }}>
              <CancelBtn />
            </Col>
            <Col>
              <OkBtn />
            </Col>
          </Row>
        ),
        width: '1040px',
        onOk() {
          handleOk();
        },
      }),
  };
};
